<div class="grid">
  <div class="col-12">
    <app-loading *ngIf="loading"></app-loading>
    <div *ngIf="!loading" class="recuadro-widget" style="width: 100%; margin: 0; position: relative; overflow: hidden;">
      <!-- Etiqueta Nuevo -->
      <div class="cinta" *ngIf="funcionalidadSIMCRE && funcionalidadSIMCRE.nuevo">Nuevo</div>

      <div class="widget-title">
        {{'WIDGETS.LBL_TITULOSIMULADOR' | translate }}
      </div>
      <div class="widget-contenido">
        <img src="../../../../../../assets/icons/simulador-credito/ico-calculadora.svg" alt="calculadora">
        <span class="widget-subtitle">{{'WIDGETS.LBL_SUBTITULOSIMULADOR' | translate }}</span>
      </div>
      <div style="display: flex;">
        <button class="btns-acciones"  label="{{'WIDGETS.BTN_SIMULADOR' | translate}}"
                    type="button" pButton (click)="irSimuladorCredito()"></button>
      </div>
    </div>
  </div>
</div>
